import { UserProfileService } from '@/app/services/user-profile'
import { ErrorResponse, PaginatedQueryResponse } from '@/types/api'
import { IToolSuggestion } from '@/types/tool-suggestion'
import { useQuery, UseQueryOptions } from 'react-query'

export function useToolsSuggestions(
  profileId: string | undefined,
  options?: Omit<
    UseQueryOptions<PaginatedQueryResponse<IToolSuggestion>, ErrorResponse>,
    'queryKey' | 'queryFn'
  >
) {
  return useQuery<PaginatedQueryResponse<IToolSuggestion>, ErrorResponse>(
    ['tools-suggestions', profileId],
    () => UserProfileService.getToolsSuggestions(profileId as string),
    {
      enabled: !!profileId?.trim(),
      ...options,
    }
  )
}
